export const GAP_WIDTH = 24;
export const MOVEMENT_BUTTON_WIDTH = 41;
